import script from "./formItem.vue?vue&type=script&setup=true&lang=js"
export * from "./formItem.vue?vue&type=script&setup=true&lang=js"

import "./formItem.vue?vue&type=style&index=0&id=7d6d4485&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6d4485"]])

export default __exports__